export const menu = [
    {
        title: '首頁',
        index: 'index',
        activeMenu: 'index',
        auths: [],
    },
    {
        title: '請款單',
        index: 'payment',
        activeMenu: 'payment',
        auths: ['A01', 'A02', 'A03', 'Q01'],
    },
    {
        title: '發票',
        index: 'invoice',
        activeMenu: 'invoice',
        auths: ['B01', 'B02', 'B03', 'Q02'],
    },
    {
        title: '勞報單',
        index: 'service-fee-statement',
        activeMenu: 'service-fee-statement',
        auths: ['H01', 'H02'],
    },
    {
        title: '專案',
        index: 'project',
        activeMenu: 'project',
        auths: ['C01', 'C01-1', 'C02', 'C03', 'C04', 'C05', 'C06', 'Q03'],
        groups: [
            {
                title: '專案、客戶',
                key: 'project-managements',
                auths: ['C01', 'C01-1', 'C02', 'C04', 'C05', 'Q03'],
                children: [
                    {
                        title: '專案管理',
                        index: 'project',
                        auths: ['C01', 'C01-1', 'C04', 'Q03'],
                    },
                    {
                        title: '專案類型設定',
                        index: 'project-type',
                        auths: ['C05'],
                    },
                    {
                        title: '客戶管理',
                        index: 'vendor',
                        auths: ['C02'],
                    },
                ],
            },
            {
                title: '廠商',
                key: 'oursourcing-managements',
                auths: ['C03', 'C06'],
                children: [
                    {
                        title: '委外管理',
                        index: 'outsourcing',
                        auths: ['C03'],
                    },
                    {
                        title: '委外類型設定',
                        index: 'outsourcing-type',
                        auths: ['C06'],
                    },
                ],
            },
        ],
    },
    {
        title: '分析',
        index: 'analysis',
        activeMenu: 'analysis',
        auths: ['D11', 'D12', 'D13', 'D14', 'D15', 'D16', 'D17', 'D18', 'D19'],
        groups: [
            {
                title: '總覽',
                key: 'analysis-g1',
                auths: ['D11', 'D12', 'D18'],
                children: [
                    {
                        title: '營業收支總覽',
                        index: 'analysis-overview',
                        auths: ['D11'],
                    },
                    {
                        title: '存款借款總覽',
                        index: 'analysis-deposit',
                        auths: ['D12'],
                    },
                    {
                        title: '自結損益表',
                        index: 'analysis-income-statement',
                        auths: ['D18'],
                    },
                    {
                        title: '年度預估營業淨收',
                        index: 'analysis-estimate-profit',
                        auths: ['D20'],
                    },
                ],
            },
            {
                title: '分析',
                key: 'analysis-g2',
                auths: ['D13', 'D14', 'D15', 'D19', 'D20'],
                children: [
                    {
                        title: '現金流量分析',
                        index: 'analysis-cash',
                        auths: ['D13'],
                    },
                    {
                        title: '營業收入分析',
                        index: 'analysis-income',
                        auths: ['D14'],
                    },
                    {
                        title: '營業支出分析',
                        index: 'analysis-payout',
                        auths: ['D15'],
                    },
                    {
                        title: '財務資產收支分析',
                        index: 'financial-analysis',
                        auths: ['D19'],
                    },
                ],
            },
            {
                title: '比較',
                key: 'analysis-g3',
                auths: ['D16', 'D17'],
                children: [
                    {
                        title: '同期比較',
                        index: 'analysis-comparison',
                        auths: ['D16'],
                    },
                    {
                        title: '客戶貢獻分析',
                        index: 'analysis-vendor',
                        auths: ['D17'],
                    },
                ],
            },
        ],
    },
    {
        title: '財務',
        index: 'finance',
        activeMenu: 'finance',
        auths: ['E01', 'Q04', 'E02', 'E03', 'E04', 'D22', 'D23', 'F13', 'F04'],
        groups: [
            {
                title: '管理',
                key: 'finance-g1',
                auths: ['E01', 'Q04', 'E02', 'E03', 'E04', 'D22', 'D23'],
                children: [
                    {
                        title: '財務收支管理',
                        index: 'variable-statement',
                        auths: ['E01', 'Q04'],
                    },
                    {
                        title: '零用現金管理',
                        index: 'petty-cash',
                        auths: ['E02'],
                    },
                    {
                        title: '人事薪資',
                        index: 'salary',
                        auths: ['E03'],
                    },
                    {
                        title: '銀行匯款明細、匯費',
                        index: 'remittances',
                        auths: ['E04'],
                    },
                    {
                        title: '借款管理',
                        index: 'loan-management',
                        auths: ['D22'],
                    },
                    {
                        title: '核銷轉開發票',
                        index: 'reimbursement-invoice',
                        auths: ['D23'],
                    },
                ],
            },
            {
                title: '小幫手',
                key: 'finance-g3',
                auths: ['F13', 'F04'],
                children: [
                    {
                        title: '收支日曆',
                        index: 'payment-calendar',
                        auths: ['F13'],
                    },
                    {
                        title: '幣別與匯率',
                        index: 'currency',
                        auths: ['F04'],
                    },
                ],
            },
        ],
    },
    {
        title: '申報',
        index: 'declaration',
        activeMenu: 'declaration',
        auths: ['G03', 'D21', 'G04', 'G05', 'G13'],
        groups: [
            {
                title: '申報幫手',
                key: 'declaration-g1',
                auths: ['G03', 'D21', 'G04', 'G05', 'G13'],
                children: [
                    {
                        title: '營業稅申報',
                        index: 'accounting-business-tax',
                        auths: ['G03'],
                    },
                    {
                        title: '外部進項發票',
                        index: 'tax-credit-invoice',
                        auths: ['D21'],
                    },
                    {
                        title: '勞務稅、健保申報',
                        index: 'accounting-personal-services-tax',
                        auths: ['G04'],
                    },
                    {
                        title: '年度扣繳申報',
                        index: 'accounting-annual-tax',
                        auths: ['G05'],
                    },
                    {
                        title: '申報文件管理',
                        index: 'application-form-management',
                        auths: ['G13'],
                    },
                ],
            },
        ],
    },
    {
        title: '會計專區',
        index: 'accounting',
        activeMenu: 'accounting',
        auths: ['G01', 'G02', 'G07', 'G08', 'G16'],
        externalLinks: [{
            text: '前往會計專區',
            url: 'https://acc.sokuji.tw/',
        }],
        groups: [
            {
                title: '會計功能',
                key: 'accounting-g1',
                auths: ['G01', 'G02', 'G08'],
                children: [
                    {
                        title: '帳務匯總表',
                        index: 'accounting-summary',
                        auths: ['G01'],
                    },
                    {
                        title: '傳票作業清單',
                        index: 'accounting-voucher-list',
                        auths: ['G08'],
                    },
                    {
                        title: '年度會計總管理',
                        index: 'accounting-yearly-management',
                        auths: ['G15'],
                    },
                    {
                        title: '會計科目設定',
                        index: 'accounting-setting',
                        auths: ['G02'],
                    },
                    {
                        title: '會計科目對照表',
                        index: 'accounting-relation-setting',
                        auths: ['G02'],
                    },
                ],
            },
            {
                title: '會計報表',
                key: 'accounting-g2',
                auths: ['G07', 'G08'],
                children: [
                    {
                        title: '綜合損益表',
                        index: 'accounting-statement',
                        auths: ['G07'],
                    },
                    {
                        title: '會計資產負債表',
                        index: 'accounting-balance-sheet',
                        auths: ['G07'],
                    },
                    {
                        title: '會計科目餘額試算表',
                        index: 'accounting-account-balance-spreadsheet',
                        auths: ['G07'],
                    },
                    {
                        title: '會計科目總分類帳',
                        index: 'accounting-general-ledger',
                        auths: ['G08'],
                    },
                ],
            },
            {
                title: '專案會計報表',
                key: 'accounting-g3',
                auths: ['G16'],
                children: [
                    {
                        title: '專案綜合損益表',
                        index: 'project-accounting-statement',
                        auths: ['G16'],
                    },
                    {
                        title: '專案資產負債表',
                        index: 'project-accounting-balance-sheet',
                        auths: ['G16'],
                    },
                ],
            },
        ],
    },
    {
        title: '設定',
        index: 'settings',
        activeMenu: 'settings',
        auths: ['F01', 'F02', 'F03', 'F03-1', 'F05', 'F14', 'F24', 'F22', 'F23'],
        groups: [
            {
                title: '設定',
                key: 'settings-g1',
                auths: ['F01', 'F02', 'F03', 'F03-1', 'F05', 'F24', 'F14', 'F22', 'F23'],
                children: [
                    {
                        title: '特定費用設定',
                        index: 'special-disbursement-project',
                        auths: ['F01'],
                    },
                    {
                        title: '經常性費用設定',
                        index: 'current-expenditure',
                        auths: ['F02'],
                    },
                    {
                        title: '銀行帳戶設定',
                        index: 'bank-account',
                        auths: ['F03', 'F03-1'],
                    },
                    {
                        title: '收支項目設定',
                        index: 'trade-statement',
                        auths: ['F05'],
                    },
                    {
                        title: '發票字軌管理',
                        index: 'invoice-serial-number',
                        auths: ['F24'],
                    },
                    {
                        title: '營收目標設定',
                        index: 'revenue-goal',
                        auths: ['F14'],
                    },
                    {
                        title: '審核流程設定',
                        index: 'audit-flow',
                        auths: ['F22'],
                    },
                    {
                        title: '公司資訊設定',
                        index: 'company-info',
                        auths: ['F23'],
                    },
                ],
            },
        ],
    },
];

export default menu;
